<template>
  <div class="main-page">
    <VideoBlock />
    <OurProjects />
    <div class="main-page__separator"></div>
    <Services />
    <WorkProcesses />
    <Faq />
    <ProjectPanorama />
    <div class="main-page__request-form container" id="request-form">
      <AppRequestForm />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VideoBlock from './components/VideoBlock/Index.vue'
import OurProjects from './components/OurProjects/Index.vue'
import Services from './components/Services/Index.vue'
import WorkProcesses from './components/WorkProcesses/Index.vue'
import Faq from './components/Faq/Index.vue'
import ProjectPanorama from './components/ProjectPanorama/Index.vue'
import AppRequestForm from '@/components/global/AppRequestForm/Index.vue'

export default defineComponent({
  name: 'MainPage',
  components: {
    VideoBlock,
    OurProjects,
    Services,
    WorkProcesses,
    Faq,
    ProjectPanorama,
    AppRequestForm,
  },
})
</script>

<style lang="scss" scoped>
.main-page {
  &__separator {
    @include main-page-block-default-margin;
    width: 100%;
    height: 4px;
    background: #e1d8d8;
  }

  &__request-form {
    @include main-page-block-default-margin;
  }
}
</style>
